import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMyReservations } from '../../api/queries.js';
import { ReservationStatus } from '@waw/shared-types';

const STATUS_LABELS = {
  [ReservationStatus.PENDING_PAYMENT]: 'Paiement en attente',
  [ReservationStatus.PENDING_VALIDATION]: 'Validation en cours',
  [ReservationStatus.CONFIRMED]: 'Confirmee',
  [ReservationStatus.CANCELLED]: 'Annulee',
  [ReservationStatus.REJECTED]: 'Refusee',
};

const STATUS_BADGE = {
  [ReservationStatus.PENDING_PAYMENT]: 'badge-pending',
  [ReservationStatus.PENDING_VALIDATION]: 'badge-pending',
  [ReservationStatus.CONFIRMED]: 'badge-confirmed',
  [ReservationStatus.CANCELLED]: 'badge-cancelled',
  [ReservationStatus.REJECTED]: 'badge-cancelled',
};

export default function MyReservations() {
  const [page, setPage] = useState(1);
  const { data, isLoading, isError } = useMyReservations(page);

  const reservations = data?.reservations || [];
  const totalPages = data?.totalPages || 1;

  return (
    <div className="container" style={{ paddingTop: 'var(--space-6)', paddingBottom: 'var(--space-8)', maxWidth: 700, margin: '0 auto' }}>
      <h1 style={{ fontSize: 'var(--font-size-lg)', fontWeight: 700, marginBottom: 'var(--space-3)' }}>
        Mes reservations
      </h1>

      {isLoading && (
        <div style={{ display: 'grid', gap: 'var(--space-2)' }}>
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="card skeleton" style={{ height: 100 }} />
          ))}
        </div>
      )}

      {isError && (
        <div className="card" style={{ padding: 'var(--space-4)', textAlign: 'center' }}>
          <p style={{ color: 'var(--waw-pink)' }}>
            Impossible de charger vos reservations.
          </p>
        </div>
      )}

      {!isLoading && !isError && reservations.length === 0 && (
        <div className="card" style={{ padding: 'var(--space-6)', textAlign: 'center' }}>
          <p style={{ color: 'var(--text-muted)', marginBottom: 'var(--space-2)' }}>
            Aucune reservation pour le moment.
          </p>
          <Link to="/" className="btn btn-primary">
            Reserver maintenant
          </Link>
        </div>
      )}

      {reservations.length > 0 && (
        <div style={{ display: 'grid', gap: 'var(--space-2)' }}>
          {reservations.map((r) => (
            <Link
              key={r.id || r.code}
              to={`/reservation/${r.code}`}
              className="card card-interactive"
              style={{ padding: 'var(--space-3)', textDecoration: 'none', color: 'inherit' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--space-1)' }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 'var(--font-size-base)' }}>
                    {r.eventTypeName || r.eventType}
                  </div>
                  <div style={{ fontSize: 'var(--font-size-sm)', color: 'var(--text-muted)' }}>
                    {r.siteName || r.site}
                  </div>
                </div>
                <span className={`badge ${STATUS_BADGE[r.status] || 'badge-pending'}`}>
                  {STATUS_LABELS[r.status] || r.status}
                </span>
              </div>
              <div style={{ display: 'flex', gap: 'var(--space-3)', fontSize: 'var(--font-size-sm)', color: 'var(--text-secondary)' }}>
                <span>{r.date}</span>
                <span>{r.startTime}</span>
                <span>{r.participants} participant{r.participants > 1 ? 's' : ''}</span>
              </div>
            </Link>
          ))}
        </div>
      )}

      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 'var(--space-1)', marginTop: 'var(--space-4)' }}>
          <button
            className="btn btn-secondary btn-sm"
            disabled={page <= 1}
            onClick={() => setPage((p) => p - 1)}
          >
            Precedent
          </button>
          <span style={{ display: 'flex', alignItems: 'center', padding: '0 var(--space-2)', fontSize: 'var(--font-size-sm)', color: 'var(--text-muted)' }}>
            {page} / {totalPages}
          </span>
          <button
            className="btn btn-secondary btn-sm"
            disabled={page >= totalPages}
            onClick={() => setPage((p) => p + 1)}
          >
            Suivant
          </button>
        </div>
      )}
    </div>
  );
}
